<template>
  <wizard-form v-bind="ouiaProps" :hidden="hidden" :title="$t('Intestazione')">
    <wizard-question-yesno :title="$t('A chi vuoi intestare l\'offerta?')" name="fattura_me" required v-model="wizard.fatturaMe">
      <template #label-yes> {{ $t('Direttamente a me') }}:</template>
      <template #description-yes>
        {{ $t('Intestazione e fatturazione a {0} con sconto del {1}%', [login.azienda, login.sconto]) }}
      </template>
      <template #label-no>
        {{ $t('Ad un mio cliente') }}
      </template>
      <template #description-no>
        {{ $t('Intestazione e fatturazione al tuo cliente. Riceverai le relative provvigioni, al saldo fattura, sul conto Artera.') }}
      </template>
    </wizard-question-yesno>

    <wizard-question v-if="!wizard.fatturaMe" :title="$t('A quale cliente vuoi intestare l\'offerta?')">
      <pf-empty-state v-if="!ready">
        <pf-empty-state-header :title="$t('Stiamo caricando la tua lista clienti...')" heading-level="h4">
          <template #icon>
            <pf-empty-state-icon>
              <pf-spinner />
            </pf-empty-state-icon>
          </template>
        </pf-empty-state-header>
        <pf-empty-state-body>
          {{ $t('Ancora pochi istanti e potrai continuare la tua offerta') }}
        </pf-empty-state-body>
      </pf-empty-state>

      <template v-else-if="wizard.customers.length > 0" v-for="c of wizard.customers" :key="c.id">
        <pf-radio
          :label="c.ragione_sociale"
          name="idClienteFinale"
          required
          :value="c.id"
          :checked="wizard.customer?.id === c.id"
          @change="wizard.idClienteFinale = Number(($event.target as HTMLInputElement).value)"
          :ouia-id="`wizard-select-customer-id-${c.id}`"
        />
      </template>

      <div v-if="ready && !wizard.customers.length">
        {{ $t('Nessun cliente trovato, clicca sul pulsante qui sotto per inserire un nuovo prospect') }}
        <input type="text" required style="display: none" />
      </div>
    </wizard-question>

    <template v-if="!wizard.fatturaMe">
      <pf-button @click="openFromProspect = true" class="pf-v6-u-mt-md" data-ouia-component-id="new-prospect-button" style="max-width: 300px">
        {{ $t("Crea un'azienda prospect") }}
      </pf-button>
      <form-prospect
        v-if="openFromProspect"
        modal
        v-model:open="openFromProspect"
        :title="$t('Inserisci un nuovo prospect')"
        variant="medium"
        :key="formKey"
        v-model:id-prospect="wizard.idClienteFinale"
        @submit="refreshCustomers"
      />
    </template>

    <wizard-question-yesno
      v-if="wizard.fatturaMe"
      :title="$t('Si tratta di un\'offerta di prodotti da rivendere a un cliente finale?')"
      name="not_for_resale"
      required
      v-model="wizard.notForResale"
      :label-no="$t('Sì')"
      :label-yes="$t('No: da attivare per uso interno (not for resale)')"
      first-no
    />

    <pf-flex>
      <pf-flex-item>
        <wizard-question v-if="wizard.askTest" :title="$t('Vuoi attivare questo servizio in prova per 30 giorni?')">
          <pf-switch v-model:checked="wizard.freePeriod" :value="true" off-value="0" :label="wizard.freePeriod ? $t('Sì') : $t('No')" />
        </wizard-question>
      </pf-flex-item>
      <pf-flex-item>
        <wizard-question-yesno
          v-if="wizard.freePeriod"
          :title="$t('Cosa vuoi fare al termine del test?')"
          :label-yes="$t('Rinnova dopo il periodo gratuito')"
          :label-no="$t('Disdici dopo il periodo gratuito')"
          name="renew_after_free_period"
          v-model="wizard.renewAfterFreePeriod"
        />
      </pf-flex-item>
    </pf-flex>
  </wizard-form>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { useOUIAProps, type OUIAProps } from '@common/ouia';
import { useWizardStep } from '@/wizard';
import FormProspect from '../../form-prospect.vue';
import WizardForm from '../wizard-form.vue';
import WizardQuestion from '../questions/wizard-question.vue';
import WizardQuestionYesno from '../questions/wizard-question-yesno.vue';
import { useLoginStore } from '@/store/login.ts';

defineOptions({
  name: 'WizardStepClienti',
});

const props = defineProps<OUIAProps>();
const ouiaProps = useOUIAProps(props);

const { wizard, hidden, isEnabled } = useWizardStep({
  isEnabled: wizard => true,
});

const openFromProspect = ref(false);
const formKey = ref(0); // utilizzata per effettuare il reset del form

const ready = computed(() => wizard.customersState.state === 'success');

const login = useLoginStore();

function refreshCustomers() {
  formKey.value += 1;
  wizard.customersState.update();
  openFromProspect.value = false;
}

defineExpose({
  isEnabled,
});
</script>
